import { getList as _getList, add as _add, update as _update, deleteAll as _deleteAll, getOneById as _getOneById } from "../../api";
import { dateToString } from "utils/dateUtils";

const BASE_URL = "/pos/entries/master";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "date",
    orderDirection: "desc",
    pageNumber: 0,
    pageSize: 5,
};

function normalizeMasterData(data) {
    const { date: dateInMillis } = data;

    const date = new Date(dateInMillis);

    return {
        ...data,
        date,
        dateString: dateToString(date, false),
    };
}

function normalizeData(data) {
    return data.map(normalizeMasterData);
}

export function getOneById({ id, onSuccess, onError }) {
    _getOneById({
        url: `${BASE_URL}/${id}`,
        onSuccess,
        onError,
        normalizer: normalizeMasterData,
    });
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError, normalizer: normalizeData });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}
